<script>
export default {
  name: 'TrueWalletDeposit',
  props: {
    account: { type: Object, default: () => ({}) }
  },
  computed: {
    mobile () { return String(this.account.mobile || '').trim() },
    copyNumber () { return this.mobile.replace(/\D/g, '') }
  }
}
</script>

<template>
  <section v-if="mobile" class="truewallet-deposit" aria-label="ฝากผ่านทรูมันนี่ วอลเล็ท">
    <div class="truewallet-account">
      <img src="../../assets/images/bank/tmw.png" width="50" height="50" alt="TrueMoney Wallet">
      <div>
        <div>ทรูมันนี่ วอลเล็ท</div>
        <div>{{ account.firstname }} {{ account.lastname }}</div>
        <strong id="depositBankNumber2">{{ mobile }}</strong>
      </div>
    </div>
    <button
      v-clipboard:copy="copyNumber"
      v-clipboard:success="() => $emit('copied')"
      type="button"
      class="btn btn-primary mt-2"
    >คัดลอกเบอร์ทรูมันนี่</button>
  </section>
</template>

<style scoped>
.truewallet-deposit { padding: 12px 16px; text-align: center; font-family: 'Kanit', sans-serif; color: #fff; }
.truewallet-account { display: flex; align-items: center; justify-content: center; gap: 16px; padding: 16px; background: rgba(255,255,255,.1); border-radius: 12px; }
.truewallet-account img { border-radius: 50%; }
.truewallet-account strong { font-size: 22px; overflow-wrap: anywhere; }
.truewallet-deposit .btn-primary { background: #edb848; color: #1b1711; border-color: #edb848; }
</style>
